import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { Parameter } from "../models/Parameter";
import { PartCreateDTO } from "../models/Parts/PartCreateDTO";
import { PartDTO } from "../models/Parts/PartDTO";
import { PartUpdateDTO } from "../models/Parts/PartUpdateDTO";
import { APIService } from "./APIService";
import { SearchPartByName } from "../models/Parts/SearchPartByName"

export class PartService {

    async GetAll(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<PartDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Part/GetAll`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<PartDTO>(
                false,
                "Erro ao obter a informação das peças",
                "",
                [],
                0,
            );
        }
    }

    async GetPartsAndHoursTotalPrice(assistanceId: number): Promise<MessagingHelper<number>> {
        try {    
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Part/GetPartsAndHoursTotalPrice/${assistanceId}`,
                null,
                {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + APIService.GetToken(),
                    },
                }
            );
        
            return response.data;

        } catch (error) {
            return new MessagingHelper<number>(false, 'Erro ao obter o valor total das peças e horas', 0);
        }
    }    

    async GetByReference(
        searchParams: PartDTO,
    ): Promise<MessagingHelper<PartDTO[] | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Part/GetPartByReference`,
                {
                    ...searchParams,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a informação das peças pela referência",
                null
            );
        }
    }

    async CreatePart(createPart: PartCreateDTO): Promise<MessagingHelper<number>> {
        try {
            var response = await APIService.Axios().post(`${APIService.GetURL()}/Part/Create`,
                {
                    ...createPart
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + APIService.GetToken()
                    }
                });
            return response.data;
        } catch (error) {
            return new MessagingHelper<number>(false, "Erro ao ligar ao servidor para criar a peça", 0);
        };
    }

    async GetByIdErp(idErp: string | undefined): Promise<MessagingHelper<PartDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Part/${idErp}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a informação da peça",
                null
            );
        }
    }

    async SearchPartByName(
        searchParams: SearchPartByName,
    ): Promise<MessagingHelper<PartDTO[] | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Part/SearchByName`,
                {
                    ...searchParams,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },  
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a informação dos clientes",
                null
            );
        }
    }

    async Edit(partUpdate: PartUpdateDTO): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Part/Edit`,
                { ...partUpdate },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para atualizar a peça",
                null,
            );
        }
    }
}